import script from "./HelpFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpFeedback.vue?vue&type=script&setup=true&lang=js"

import "./HelpFeedback.vue?vue&type=style&index=0&id=0c091f42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c091f42"]])

export default __exports__